import React from 'react'
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint'
import AirDna from 'src/Components/shared/AirDna'

const propTypes = {
  stateKey: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired
}

const WaypointAirDna = ({ stateKey, onEnter, locked, showNightlyRentals }) => (
  <>
    <Waypoint onEnter={onEnter}>
      <div />
    </Waypoint>
    <AirDna
      hideEdit
      stateKey={stateKey}
      showNightlyRentals={showNightlyRentals}
      locked={locked}
    />
  </>
)

WaypointAirDna.propTypes = propTypes

export default WaypointAirDna
